module.exports = __webpack_public_path__ + "img/pic_2.5910dbab.png";